import { Pagination } from './../function/paginate';
import { ProjectListMapItem, ProjectListPageSearchResults } from './../typings/backend-models';
import cardsPagination from './pagination';

const getData = async (url: string) => {
    const res = await fetch(url).then((response) => response.json());
    return res;
};

const createListItem = (properties: ProjectListMapItem) => {
    const { imageSrcUrl, dateAndPlace, title, description, contentUrl } = properties;

    const listItemEl = document.createElement('li');
    listItemEl.classList.add('entryblock');

    const content = `
        <a class="entryblock__link" href="${contentUrl}">
            <div class="entryblock__image ratio ratio--1-1">
                <img class="ratio__item ratio__item--cover" alt="" src="${imageSrcUrl}" />
            </div>

            <div class="entryblock__content">
                <p class="entryblock__date">${dateAndPlace}</p>
                <h3 class="entryblock__title">${title}</h3>
                <p class="entryblock__text">${description}</p>
                <svg class="vd-icon vd-icon-arrow-right" width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" fill="currentColor">
                <polygon points="29.83 5.73 27 8.55 40.01 21.56 40.01 22 4.02 22 4.02 26 40.01 26 40.01 26.44 26.98 39.45 29.81 42.28 44.01 28.1 44.01 19.91 29.83 5.73"></polygon>
                </svg>
            </div>
        </a>
  `;
    listItemEl.innerHTML = content;
    return listItemEl;
};

const createList = (elements: ProjectListMapItem[]) => {
    const productCardsEl = document.querySelector('.project-cards');
    const productsCardsListEl = productCardsEl.querySelector('.project-cards__list');
    productsCardsListEl.innerHTML = '';

    elements.forEach((element) => {
        const listItem = createListItem(element);
        productsCardsListEl.append(listItem);
    });
};

export const filterResults = (list: ProjectListMapItem[], searchData: ProjectListPageSearchResults) => {
    const { pageSearchHits } = searchData;
    const resultIds = pageSearchHits.map((item) => item.contentLinkId);
    const newList = list.filter((item) => resultIds.includes(item.contentLinkId));

    return newList;
};

export const getUrlData = (): { catIds: number[]; searchTerm: string } => {
    const catIds = [];
    let searchTerm: string = '';
    const url = new URL(window.location.href);

    for (const [key, value] of url.searchParams.entries()) {
        if (key === 'catids') {
            if (value != null) {
                const commaSeparatedValuesOrNot = value.split(",");
                for (const val of commaSeparatedValuesOrNot) {
                    catIds.push(Number(val));
                }
            } 
        } else if (key === 'q') {
            searchTerm = value;
        }
    }

    return { catIds, searchTerm };
};

export const getSearchResults = async ({
    guuid,
    langId,
    catIds,
    searchTerm,
}: {
    guuid: string;
    langId: number;
    catIds: number[];
    searchTerm: string;
}): Promise<ProjectListPageSearchResults> => {
    const mainUrl: string = window.location.origin;
    const apiUrl = `${mainUrl}/api/map/ProjectListPageSearchResults/${guuid}/${langId}?catIds=${catIds.toString()}&q=${searchTerm}`;
    const data = await getData(apiUrl);
    return data;
};

export const getSearchResultsWithoutDisabledProjects = async ({
   guuid,
   langId,
   catIds,
   searchTerm,
}: {
    guuid: string;
    langId: number;
    catIds: number[];
    searchTerm: string;
}): Promise<ProjectListPageSearchResults> => {
    const searchData = await getSearchResults({guuid, langId, catIds, searchTerm});
    searchData.pageSearchHits = searchData.pageSearchHits.filter(hit => hit.pageIsDisabled === false);
    searchData.pageSearchHitsCount = searchData.pageSearchHits.length;
    return searchData;
};

const updateList = async ({
    searchTerm,
    guuid,
    langId,
    initialList,
}: {
    searchTerm: string;
    guuid: string;
    langId: number;
    initialList: ProjectListMapItem[];
}) => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    searchParams.delete('q');
    searchParams.append('q', searchTerm);
    url.search = searchParams.toString();
    history.pushState({}, null, url.toString());

    const productCardsEl = document.querySelector('.project-cards');
    const productsCardsListEl = productCardsEl.querySelector('.project-cards__list');

    const { catIds } = getUrlData();
    const searchDataWithoutDisabledProjects = await getSearchResultsWithoutDisabledProjects({ guuid, langId, catIds, searchTerm });
    const filteredList = filterResults(initialList, searchDataWithoutDisabledProjects);

    productsCardsListEl.innerHTML = '';

    const paginationEl = document.querySelector('.pagination-dynamic');
    const paginationWrapperEl = paginationEl.querySelector('.pagination__wrapper');
    paginationWrapperEl.innerHTML = '';

    cardsPagination(searchDataWithoutDisabledProjects, (pagination) => handlePageChange(pagination, filteredList));
    handleNoResultsMessage(searchDataWithoutDisabledProjects.pageSearchHitsCount < 1);
};

const clearList = (): void => {
    const productCardsEl = document.querySelector('.project-cards');
    const productsCardsListEl = productCardsEl.querySelector('.project-cards__list');
    productsCardsListEl.innerHTML = '';
};

const handlePageChange = (paginationData: Pagination, filteredList: ProjectListMapItem[]) => {
    const { startIndex, endIndex } = paginationData;
    const slicedList = filteredList.slice(startIndex, endIndex + 1);

    clearList();
    createList(slicedList);
};

const handleNoResultsMessage = (isVisible: boolean) => {
    let noResultsDiv = document.getElementById("no-results-placeholder");
    if (noResultsDiv) {
        if (!isVisible) {
            noResultsDiv.style.display = "none";
        } else {
            noResultsDiv.style.display = "block";
        }
    }
}

const projectCards = async () => {
    const productCardsEl = document.querySelector('.project-cards');
    if (!productCardsEl) return;
    const productsCardsListEl = productCardsEl.querySelector('.project-cards__list');
    const inputWrapperEl = document.querySelector('.input-search-wrapper') as HTMLInputElement;
    const inputEl = inputWrapperEl.querySelector('.input-cards-filter') as HTMLInputElement;
    const iconEl = inputWrapperEl.querySelector('.search-icon') as HTMLInputElement;
    const filterBoxEl = document.querySelector('.filter-box');

    const { lang, guuid } = (productsCardsListEl as HTMLElement).dataset;
    const langId = Number(lang);
    const mainUrl: string = window.location.origin;
    const projectListApiUrl: string = `${mainUrl}/api/map/ProjectListPageMap/${guuid}/${lang}`;

    const { catIds, searchTerm } = getUrlData();
    const allProjectsData = await getData(projectListApiUrl);
    const searchDataWithoutDisabledProjects = await getSearchResultsWithoutDisabledProjects({ guuid, langId, catIds, searchTerm });
    handleNoResultsMessage(searchDataWithoutDisabledProjects.pageSearchHitsCount < 1);
    const filteredList = filterResults(allProjectsData.mapItems, searchDataWithoutDisabledProjects);

    inputEl.value = searchTerm;
    inputEl.onkeyup = function (e) {
        const event = e as KeyboardEvent;
        if (event.key === 'Enter') {
            const searchTerm: string = event.target['value'];
            updateList({ searchTerm, guuid, langId, initialList: allProjectsData.mapItems });
        }
    };
    iconEl.addEventListener('click', function () {
        updateList({ searchTerm: inputEl.value, guuid, langId, initialList: allProjectsData.mapItems });
    });

    if (filterBoxEl) {
        const filterSubmitButtonEl = filterBoxEl.querySelector('.filter-button--submit');
        const filterAbortButtonEl = filterBoxEl.querySelector('.filter-button--abort');

        filterSubmitButtonEl.addEventListener('click', function () {
            updateList({ searchTerm, guuid, langId, initialList: allProjectsData.mapItems });
        });
        filterAbortButtonEl.addEventListener('click', function () {
            updateList({ searchTerm, guuid, langId, initialList: allProjectsData.mapItems });
        });
    }

    cardsPagination(searchDataWithoutDisabledProjects, (pagination) => handlePageChange(pagination, filteredList));
};

projectCards();
